export const ModelList = [
    {
        'group':'Rhodo',
        'name':'Models',
        'models':
        [
            {name:'ALL_RHODO_F',url:'./models/ALL_RHODO_F.glb'},
            {name:'Google',url:'./models/Google.glb'},
            {name:'Rhodo_F',url:'./models/Rhodo_F.glb'},
            {name:'Workings',url:'./models/Workings.glb'},
        ]
    }
]